export const DEFAULT_FORM_NAME = "sign-up-fresh";

const FORM_NAME_MAP: Record<string, string> = {
  "/sign-up/fresh": DEFAULT_FORM_NAME,
  "/forms/fresh-new-user": "fresh-new-user",

};

/**
 * Determines form name from a pathname
 * @param pathname - The pathname (e.g., "/sign-up/fresh/recipes")
 * @returns The form name, or DEFAULT_FORM_NAME as default
 */
export function determineFormNameFromPath(pathname: string): string | null {
  if (!pathname) {
    return null;
  }

  for (const [ path, formName ] of Object.entries(FORM_NAME_MAP)) {
    if (pathname === path || pathname.startsWith(`${path}/`)) {
      return formName;
    }
  }

  /**
   * Don't fallback to any flow as we don't want to redirect e.g. /products?AC_ID=test&discount_code=MEOWAC30
   * to the suf, as if they enter the SUF via the AC flow and then try to navigate away whilst still having the
   * query params, it will redirect them back to the SUF.
  */
  return null;
}
